'use strict'

'use strict'

var Marionette = require('marionette')
var App = require('app')
var ListComponent = require('src/components/list-view')

// -----
var ListItem = ListComponent.ItemView.extend({
  templateContext: function () {
    var self = this
    return {
      getListColumns: function () {
        return self.options.columns
      },
      getHideClasses: App.TemplateHelpers.getHideClasses(self.options),                   
      getColumnField: function (field) {
        var value = _.get(this, field)

        switch (field) {
          case 'type':
            return App.TemplateHelpers.getDeviceTypeLabel(value)
            break
          case 'createdAt':
            return App.TemplateHelpers.formatTime(value)
            break
          default:
            return value
            break
        }
      }
    }
  }
})
module.exports.listItem = ListItem


// -- List Component which supports paginating and bulk edit
var listView = ListComponent.ListView.extend({})

module.exports.listView = listView

// -- Layoutview constructing the client-nodes list
var LayoutView = Marionette.View.extend({
  template: require('./templates/layout.html'),
  triggers: {
    'click .js-add': 'client:add',
    'click .js-toggle-list': 'toggle:list',
    'click .js-toggle-map': 'toggle:map'
  },
  regions: {
    listRegion: {
      el: '.list-region',
      replaceElement: false
    }
  },
  initialize: function () {
    var self = this
    this.listenTo(this.collection, 'request', function () {
      self.el.classList.add('loading')
    })

    this.listenTo(this.collection, 'sync add remove', function () {
      setTimeout(function () {
        self.el.classList.remove('loading')
      }, 500)
      self.el.querySelector('.result-header__status .label').innerHTML = 'Your filter returned ' + this.collection.state.totalRecords + ' results.'
    })
  },
  onRender: function () {
   this.el.querySelector('.result-header__status .label').innerHTML = 'Your filter returned ' + this.collection.state.totalRecords + ' results.'
  },
  templateContext: function () {
    var self = this
    return {
      userHasRole: App.TemplateHelpers.userHasRole
    }
  }
})

module.exports.layout = LayoutView




// WEBPACK FOOTER //
// ./js/modules/groups/list/view.js